export const REAL_ESTATE_FILTER_BLOCK = 'RealEstateFilterBlock';
export const REAL_ESTATE_DATA_BLOCK = 'RealEstateDataBlock';
export const REAL_ESTATE_FILTER_CONTAINER_BLOCK = 'RealEstateFilterContainerBlock';
